import { CommentActions } from 'semantic-ui-react';
import {
    SET_SIDEBAR_VISIBILITY,
    FETCH_ROUTE_PROGRESS,
    FETCH_ROUTE_SUCCESS,
    FETCH_ROUTE_FAILED,
    FETCH_START_SUGGESTIONS,
    FETCH_DESTINATION_SUGGESTIONS,
    SET_START,
    SET_DESTINATION,
    SELECT_ROUTE,
    CLEAN_START,
    CLEAN_DESTINATION,
    START_START_SEARCH,
    START_DESTINATION_SEARCH,
    FINISH_START_SEARCH,
    FINISH_DESTINATION_SEARCH,
    OPEN_PARKING_LOT_POPUP,
    CLOSE_PARKING_LOT_POPUP,
    SET_DATE_TIME,
    SWAP_LOCATIONS,
    ALTERNATE_START,
    ALTERNATE_DESTINATION,
} from '../actions/types';

//  dirty way of handling cases where the values have not been set yet; associated with try-catches
const intialState = {
    startSuggestions: [],
    destinationSuggestions: [],
    times: [0, 0, 0],
    departureTimes: [0, 0, 0],
    parkingTimes: [0, 0, 0],
    arrivalTimes: [0, 0, 0],
    parkingLotNames: [0, 0, 0],
    selectedRoute: 0,
    hideGuide: true,
    startLoading: false,
    startResults: [],
    startValue: '',
    destinationLoading: false,
    destinationResults: [],
    destinationValue: '',
    route: [],
    selectedStart: '',
    selectedDestination: '',
    parkingPrices: [],
    parkingLotAddresses: [],
    isLoading: null,
    dateTime: null,
    sideBarVisible: true,
}

export default function (state = intialState, action) {
    switch (action.type) {
        // for setting sidebar visiblity
        case SET_SIDEBAR_VISIBILITY:
            return {
                ...state,
                sideBarVisible: !state.sideBarVisible
            };

        //  getting route between start andn destination

        case FETCH_ROUTE_PROGRESS:
            return {
                ...state,
                // set the loading status to 1 for API call progress
                isLoading: 1
            };
        case FETCH_ROUTE_SUCCESS:
            return {
                ...state,
                // set the loading status to 2 for API call success
                isLoading: 2,

                //  store whole query results
                route: action.payload.routes,

                //  store the routes' durations
                times: action.times,

                //  store the routes' departure times
                departureTimes: action.departureTimes,

                //  store the routes' arrivatl times at their respective parking lots
                parkingTimes: action.parkingTimes,

                //  store the routes' arrival times
                arrivalTimes: action.arrivalTimes,

                //  store the routes' respective parking lot names
                parkingLotNames: action.parkingLotNames,

                parkingLotLocations: action.parkingLotLocations,

                parkingPrices: action.parkingPrices,

                parkingLotAddresses: action.parkingLotAddresses,

                //  center on the (selected) route, the first route being the default
                center: 'route',

                //  guide should be shown now
                hideGuide: false,

            };
        case FETCH_ROUTE_FAILED:
            return {
                ...state,
                // set loading status to 0 if API call failure
                isLoading: 0
            }
        case FETCH_START_SUGGESTIONS:
            return {
                ...state,
                startSuggestions: action.payload,
            }

        case FETCH_DESTINATION_SUGGESTIONS:
            return {
                ...state,
                destinationSuggestions: action.payload,
            }
        case SET_START:
            return {
                ...state,
                selectedStart: action.payload,
                startValue: action.payload.title,
                startCoordinates: action.payload.coordinates,
                center: 'start',
                hideGuide: true,
            }
        case SET_DESTINATION:
            return {
                ...state,
                selectedDestination: action.payload,
                destinationValue: action.payload.title,
                destinationCoordinates: action.payload.coordinates,
                center: 'destination',
                hideGuide: true,
            }
        case SWAP_LOCATIONS:
            return {
                ...state,
                selectedStart: action.newStart,
                startValue: action.newStart.title,
                startCoordinates: action.newStart.coordinates,
                selectedDestination: action.newDestination,
                destinationValue: action.newDestination.title,
                destinationCoordinates: action.newDestination.coordinates,
                center: 'route',
                hideGuide: true,
            }
        case ALTERNATE_START:
            return {
                ...state,
                selectedStart: '',
                startValue: '',
                startCoordinates: '',
                selectedDestination: action.newDestination,
                destinationValue: action.newDestination.title,
                destinationCoordinates: action.newDestination.coordinates,
                center: 'destination',
                hideGuide: true,
            }
        case ALTERNATE_DESTINATION:
            return {
                ...state,
                selectedStart: action.newStart,
                startValue: action.newStart.title,
                startCoordinates: action.newStart.coordinates,
                selectedDestination: '',
                destinationValue: '',
                destinationCoordinates: '',
                center: 'start',
                hideGuide: true,
            }
        case SELECT_ROUTE:
            return {
                ...state,
                selectedRoute: action.index,
                center: 'parkingLot'
            }
        case CLEAN_START:
            return {
                ...state,
                startLoading: false,
                startResults: [],
                startValue: '',
                startCoordinates: undefined
            }
        case CLEAN_DESTINATION:
            return {
                ...state,
                destinationLoading: false,
                destinationResults: [],
                destinationValue: '',
                destinationCoordinates: undefined
            }
        case START_START_SEARCH:
            return {
                ...state,
                startLoading: true,
                startValue: action.query
            }
        case START_DESTINATION_SEARCH:
            return {
                ...state,
                destinationLoading: true,
                destinationValue: action.query
            }
        case FINISH_START_SEARCH:
            return {
                ...state,
                startLoading: false,
                startResults: action.payload,
            }
        case FINISH_DESTINATION_SEARCH:
            return {
                ...state,
                destinationLoading: false,
                destinationResults: action.payload,
            }
        case OPEN_PARKING_LOT_POPUP:
            return {
                ...state,
                parkingLotPopupVisible: true,
            }
        case CLOSE_PARKING_LOT_POPUP:
            return {
                ...state,
                parkingLotPopupVisible: false,
            }
        case SET_DATE_TIME:
            return {
                ...state,
                dateTime: action.dateTime,
                hideGuide: true,
            }
        default:
            return state;
    }
}